export const meadowsSpecificationData = [
  {
    id: "foundation_structure",
    title: "Foundation & Structure",
    points: [
      {
        text: "RCC framed structure with red brick/aerocon block/fly ash/solid block masonry.",
      },
    ],
  },
  {
    id: "plastering",
    title: "Plastering",
    points: [
      { label: "Internal", text: "Sand faced cement plaster finish." },
      { label: "External", text: "Double coat cement plastering." },
    ],
  },
  {
    id: "flooring",
    title: "Flooring",
    points: [
      { text: "Vitrified tile in foyer, living, family and dining area." },
      { text: "Laminated flooring in bedrooms and home theatre." },
      {
        text: "Vitrified/Ceramic tiles for toilet floor and walls up to lintel height.",
      },
      { text: "Anti-skid flooring for balconies." },
      { text: "Ceramic tile flooring with dado for domestic staff room." },
    ],
  },
  {
    id: "toilets",
    title: "Toilets",
    points: [
      { text: "Pressure tested CPVC piping for internal water lines." },
      { text: "PVC piping for internal drain/sewage line and shaft plumbing systems." },
      {
        text: "Water efficient sanitary ware and CP fittings (Grohe/Duravit/Kohler/Vitra or equivalent).",
      },
      { text: "Granite counter for wash basin in all toilets." },
      { text: "Provision for exhaust fans in toilets." },
    ],
  },
  {
    id: "plumbing_system",
    title: "Plumbing System",
    points: [
      {
        text: "Hydro-pneumatic water supply system for toilets and kitchen to ensure sufficient water pressure.",
      },
      { text: "External sewage plumbing lines and rainwater piping in PVC." },
      { text: "Water treatment plant and solid waste management." },
      { text: "Rainwater recharge system." },
      { text: "RO water provision for each villa separately." },
    ],
  },
  {
    id: "doors_windows",
    title: "Doors & Windows",
    points: [
      { label: "Main Door", text: "Teak wood frame and shutter with polyurethane finish." },
      {
        label: "Internal Door",
        text: "Hardwood frame and flush shutter with polyurethane finish.",
      },
      { label: "Door Hardware", text: "Hafele/Yale/Dorma or equivalent." },
      {
        label: "Windows & French Doors",
        text: "UPVC frame with toughened glass (sliding/casement/fixed shutters).",
      },
      {
        label: "Door Stoppers",
        text: "Magnetic/concealed door stoppers for main door and bedrooms.",
      },
    ],
  },
  {
    id: "paint",
    title: "Paint",
    points: [
      {
        label: "External",
        text: "Two coats of acrylic exterior emulsion paint with texture finish as per approved design.",
      },
      {
        label: "Internal",
        text: "Two coats of acrylic premium emulsion paint over smooth putty finish.",
      },
    ],
  },
  {
    id: "electrical_fixture",
    title: "Electrical Fixture",
    points: [
      {
        label: "Wires",
        text: "Fire retardant low smoke wires (Finolex/RR Kabel/Lapp or equivalent).",
      },
      {
        label: "Switches",
        text: "Modular switches (Legrand/Schneider/Panasonic or equivalent).",
      },
      { label: "Power Distribution", text: "Through underground cabling." },
      {
        label: "Power Quality",
        text: "Regulated power to the entire complex along with surge suppressors.",
      },
      { label: "Backup Power", text: "100% back up with DG sets." },
      { label: "Earthing", text: "Individual earthing system for villas." },
      {
        label: "Metering",
        text: "Both normal and DG power metered through energy meter, other systems via water metering.",
      },
    ],
  },
  {
    id: "security_network",
    title: "Security Network",
    points: [
      {
        text: "CCTV cameras in identified common areas and clubhouse with monitoring and recording.",
      },
      {
        text: "Boom barriers with long range readers at entry and exit for smooth movement.",
      },
      { text: "Solar powered security fence on compound wall." },
    ],
  },
  {
    id: "communication_network",
    title: "Communication Network",
    points: [
      { text: "Telephone points in all bedrooms and living area." },
      { text: "Intercom facility throughout the property." },
      { text: "Broadband connectivity in all bedrooms/living area." },
      { text: "TV provision in all bedrooms and living area with DTH connectivity." },
      { text: "Wi-Fi connectivity in clubhouse." },
    ],
  },
  {
    id: "landscaping",
    title: "Landscaping",
    points: [
      { text: "Professionally planned and executed landscape." },
    ],
  },
  {
    id: "elevator",
    title: "Elevator",
    points: [
      { text: "Provision for MRL/hydraulic lift will be made." },
    ],
  },
];
